import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../lib/cn';

export const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-item-select text-foreground',
        primary: 'bg-primary/12 text-primary',
        success: 'bg-success-background text-success-foreground',
        warning: 'bg-warning-background text-warning-foreground',
        danger: 'bg-danger-background text-danger-foreground',
        info: 'bg-info-background text-info-foreground',
        violet: 'bg-violet-background text-violet-foreground',
        magenta: 'bg-magenta-background text-magenta-foreground',
        outline: 'border border-border text-gray-dark',
        muted: 'bg-item-select text-gray-dark',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

// forwardRef so Radix `asChild` triggers (Tooltip) can attach to it.
export const Badge = React.forwardRef(({ className, variant, ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
));
Badge.displayName = 'Badge';
